import service from './axios';

export function getoauthToken(params) {
    return service({
        url: '/v3/public/getoauthToken',
        method: 'get',
        params
    })
}
export function loginWithAccessToken(data) {
    return service({
        url: '/v3/public/loginWithAccessToken',
        method: 'post',
        data
    })
}